import React, { Fragment, useState, useEffect, useMemo } from "react"
import { appStore } from "lib/state"
import { appTools, cn } from "lib/utils"
import { ConditionalStatementButton, useConditional } from "lib/units/conditional"
import { useConditionalCtx } from "lib/units/dispute/statements/conditionals"


export default function ConditionalGroupBlock( { group, zoneref }:{ group:any, zoneref:string }){

  const { store, AppStore }:any = appStore()
  const { putItemInSpotlight, mergeConditionals }:any = useConditional()
  const { currentConditional, updateConditional }:any = useConditionalCtx()

  const [ showControls, setShowControls ] = useState<boolean>(false)
  const [ testResult, setTestResult ] = React.useState<any>()


  function parseTestResults(){
    const foundGroup = store.metas.conditionalTest?.breakdown.groups.find( (groupObj:any) => groupObj.groupref === group.groupref )
    if( foundGroup ){
      setTestResult(foundGroup.verdict)
    }
  }

  function handleButtonDrop(e:any){
    e.preventDefault()
    const data = JSON.parse(e.dataTransfer.getData("text/plain"))
    mergeConditionals({ zoneref, oldgroups: [data.groupref, group.groupref], items: [...data.items, ...group.items] })
  }

  useEffect(() => {
    if( store.metas.conditionalTest ){
      parseTestResults()
    } else {
      setTestResult(undefined)
    }
  },[store.metas.conditionalTest])

  // useEffect(() => {
  //   console.log(conditionalState)
  // },[conditionalState])


  if( group.items.length === 0 ) return <></>
  return (
    <div 
      data-type="group"
      className={cn(
        "flex justify-center items-center flex-wrap p-[2px] gap-x-2 gap-y-1 *:text-xs border border-dotted border-gray-100 cursor-pointer",
        testResult === true && "bg-green-800",
        testResult === false && "bg-red-800",
      )}
      draggable={true}
      onDragStart={(e:any) => e.dataTransfer.setData("text/plain", JSON.stringify({ ...group }))}
      onDrop={handleButtonDrop}
      onDragOver={(e:any) => e.preventDefault()}
      onMouseEnter={() => setShowControls(true)}
      onMouseLeave={() => setShowControls(false)}
    >
      { group.items.map( (refid:string, idx:number) => (
        <Fragment key={idx}>
          <ConditionalStatementButton 
            key={refid} 
            item={currentConditional.items.find( (i:any) => i.refid === refid )} 
            groupref={group.refid} 
            zoneref={zoneref} 
            location="dropzone" 
            onClick={() => {
              const item = currentConditional.items.find( (i:any) => i.refid === refid )
              console.log(item)
              if( item ) putItemInSpotlight({...item, location: "dropzone"})
            }}
          />
          { idx < (group.items.length - 1) && (
            <div className="block flex justify-center items-center text-xs text-yellow-400">OR</div>
          )}
        </Fragment>
      ))}
    </div>
  )
}